import { HARDCODED_DATE } from "../constants/date";

export function getDay(): number {
  const today = new Date();
  const isSameDay =
    HARDCODED_DATE.getFullYear() === today.getFullYear() &&
    HARDCODED_DATE.getMonth() === today.getMonth() &&
    HARDCODED_DATE.getDate() === today.getDate();

  const todayMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const hardcodedMidnight = new Date(
    HARDCODED_DATE.getFullYear(),
    HARDCODED_DATE.getMonth(),
    HARDCODED_DATE.getDate()
  );

  const msInDay = 24 * 60 * 60 * 1000;
  const diffDays =
    (todayMidnight.getTime() - hardcodedMidnight.getTime()) / msInDay;

  const isNextDay = diffDays === 1;

  if (isSameDay) {
    return 1;
  } else if (isNextDay) {
    return 2;
  } else {
    return 0;
  }
}
